import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'modal-observacao-grupo',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
  template: `
    <div class="observacao-dialog">
      <div class="observacao-header">
        <div class="observacao-header-text">
          <span class="observacao-title">Observação do grupo</span>
          <span class="observacao-sub">{{ data.grupo.tipoVeiculoDescricao }}</span>
        </div>
        <button mat-icon-button class="btn-close" (click)="cancelar()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="observacao-body">
        <mat-form-field appearance="outline" class="input-tg observacao-field">
          <mat-label>Observação</mat-label>
          <textarea matInput rows="4" [(ngModel)]="observacao"></textarea>
        </mat-form-field>
      </div>

      <div class="observacao-actions">
        <button mat-flat-button class="btn-tg-cancel" (click)="cancelar()">Cancelar</button>
        <button mat-flat-button class="btn-tg" (click)="confirmar()">Salvar</button>
      </div>
    </div>
  `,
  styles: [`
    .observacao-dialog {
      display: flex;
      flex-direction: column;
      width: 460px;
    }
    .observacao-header {
      padding: 14px 14px 14px 24px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
    }
    .observacao-header-text {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .observacao-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
    }
    .observacao-sub {
      font-size: 13px;
      color: #6b7280;
    }
    .observacao-body {
      padding: 16px 24px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .observacao-field {
      width: 100%;
    }
    .observacao-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 12px 16px;
      border-top: 1px solid #e5e7eb;
    }
  `],
})
export class ModalObservacaoGrupoComponent {
  observacao: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { grupo: { tipoVeiculoDescricao: string; observacao: string | null } },
    private dialogRef: MatDialogRef<ModalObservacaoGrupoComponent>,
  ) {
    this.observacao = data.grupo.observacao ?? ''
  }

  confirmar() {
    this.dialogRef.close({
      observacao: this.observacao,
    })
  }

  cancelar() {
    this.dialogRef.close(null)
  }
}
